import { render, staticRenderFns } from "./MgrupommppModals.vue?vue&type=template&id=79c470c2"
import script from "./MgrupommppModals.vue?vue&type=script&lang=js"
export * from "./MgrupommppModals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports